import styled from 'styled-components';
import ReactInputMask from 'react-input-mask';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => `${width}%`};

  :focus-within {
    input,
    textarea {
      border-color: var(--accent-color);
    }

    label {
      color: var(--accent-color);
    }
  }
`;

const Label = styled.label`
  background-color: white;
  transform: translateY(10px);
  align-self: flex-start;
  padding: 0 10px 0 8px;
  margin-left: 10px;
  color: var(--primary-color);
  font-weight: 500;
`;

const CustomInputMask = styled(ReactInputMask)`
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  width: ${({ width }) => `${width}%`};
`;

export { InputContainer, Label, CustomInputMask };
